
<div mat-dialog-title class="_pay-dialog-title">
	<span class="_cap">{{'EX_PAYMENT_MODAL' | translate}}</span>
	<button mat-icon-button mat-dialog-close cdkFocusInitial>
		<mat-icon aria-label="Close Dialog">close</mat-icon>
	</button>
</div>

<div mat-dialog-content>

	<div class="form-wrapper" style="min-height:410px;">

		<div class="text-center" style="margin-bottom: 20px;"><img src="/assets/images/vendors/heartland-logo.png" /></div>

		<form id="iframes" action="" method="GET">
			<div id="ss-banner"></div>

			<div class="form-row">
				<label for="iframesCardNumber">Card Number:</label>
				<div id="iframesCardNumber" class="heartland-frame-container"></div>
			</div>

			<div class="form-row">
				<label for="iframesCardExpiration">Card Expiration:</label>
				<div id="iframesCardExpiration" class="heartland-frame-container"></div>
			</div>

			<div class="form-row">
				<label for="iframesCardCvv">Card CVV:</label>
				<div id="iframesCardCvv" class="heartland-frame-container"></div>
			</div>

			<br />
			<div id="iframesSubmit" class="heartland-frame-container"></div>
		</form>
	</div>
</div>





